import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { BACKOFFICE_SELECTOR } from "../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../base/base.component";
import { AppComponent } from "../app.component";
import { NavigationEnd, Router } from "@angular/router";
import { SidebarItemModel } from "../../crossconcern/models/sidebarItem.model";
import { Location } from "@angular/common";
import { HeaderUtils } from "../../crossconcern/utilities/utils/header.utils";
import { HeaderButton } from "../../crossconcern/models/header/headerbutton.model";
import { DIM_BREAKPOINT_DESKTOP_WIDTH } from "../../crossconcern/utilities/properties/base.property";
import { AlertUtils } from "../../crossconcern/utilities/utils/alert.utils";

@Component({
    selector: BACKOFFICE_SELECTOR,
    templateUrl: "./backoffice.component.html"
})
export class BackOfficeComponent extends BaseComponent implements OnInit {

    public isSidebarOpen = true;
    public sidebarMode = "push";
    public headerButtons: HeaderButton[];

    @ViewChild("sidebar", null) private sidebarElement;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        private headerUtils: HeaderUtils,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
        this.headerButtons = [];
    }

    public ngOnInit() {
        if (window.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH) {
            this.sidebarMode = "push";
            this.isSidebarOpen = true;
        } else {
            this.sidebarMode = "over";
            this.isSidebarOpen = false;
        }
        this.handleHeader(this.router.url);
        this.handleMapActionsPosition();
        this.subscribeOnRouteChange();
    }

    @HostListener("window:resize", [
        "$event"
    ])
    public onResize(event) {
        if (event.target.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH) {
            this.sidebarMode = "push";
            this.isSidebarOpen = true;
        } else {
            this.sidebarMode = "over";
        }
        this.handleMapActionsPosition();
        this.refreshSidebar();
    }

    // Sidebar component
    public onItemClick(item: SidebarItemModel) {
        this.goToRoute(item.url);
    }

    public toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;

        this.handleMapActionsPosition();
    }

    public refreshSidebar() {
        setTimeout(() => {
            this.sidebarElement.triggerRerender();
        }, 900);
    }

    private subscribeOnRouteChange() {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.handleHeader(this.router.url);
            }
        });
    }

    // manage the header elements
    private handleHeader(path: string) {
        this.headerButtons = this.headerUtils.getElements(path);
    }

    private handleMapActionsPosition() {
        const mapActionsSections = document.getElementById("map-actions-section");
        if (mapActionsSections != null) {
            const sidebarWidth = document.getElementById("left-sidebar").offsetWidth;
            document.getElementById("map-actions-section").style.left = this.isSidebarOpen ? sidebarWidth + "px" : "0px";
        }
    }

}
